export { CollectionCategoriesDesktop } from './CollectionCategoriesDesktop';
